import React, { createElement, useEffect, useMemo, useRef, useState } from 'react';
import Checkbox from './colorful-checkbox';
import CheckboxGroupContext from './context';
import './index.scss';
const CheckboxGroup = props => {
    const { type = 'checkbox', options, name, disabled, defaultValue, children, onChange, } = props;
    const [value, setValue] = useState(defaultValue || props.value || (type === 'checkbox' ? [] : ''));
    const childrenToRender = useRef(children);
    useEffect(() => {
        if (defaultValue) {
            setValue(defaultValue);
        }
    }, [defaultValue]);
    useEffect(() => {
        onChange && onChange(value);
    }, [value]);
    const onRadioChange = (ev) => {
        const val = ev.target.value;
        if (!('value' in props && props.value)) {
            if (type === 'radio') {
                setValue(val);
            }
            else if (type === 'checkbox') {
                const { checked } = ev.target;
                if (checked) {
                    setValue(tempVal => {
                        return [...tempVal, val];
                    });
                }
                else {
                    setValue(tempVal => {
                        const vals = [...tempVal];
                        const index = vals.indexOf(val);
                        if (index > -1) {
                            vals.splice(index, 1);
                        }
                        return vals;
                    });
                }
            }
        }
    };
    childrenToRender.current = useMemo(() => {
        if (options?.length > 0) {
            return options?.map((option, i) => {
                if (typeof option === 'string' || typeof option === 'number') {
                    return (createElement(Checkbox, { type: type, key: option?.toString(), disabled: disabled, value: option, name: name, label: option, onChange: onRadioChange }));
                }
                return (createElement(Checkbox, { type: type, key: `radio-group-value-options-${option?.value || i}`, disabled: option?.disabled || disabled, value: option?.value || i, name: name, label: option?.label || '选择框', onChange: onRadioChange }));
            });
        }
        return null;
    }, [options]);
    return (createElement(React.Fragment, null,
        !childrenToRender.current?.length && '请添加子元素',
        createElement(CheckboxGroupContext.Provider, { value: { value, onChange } },
            createElement("div", { className: `au-${type}-group` }, childrenToRender.current))));
};
CheckboxGroup.displayName = 'ColorfulCheckboxGroup';
export default React.memo(CheckboxGroup);
